if (!customElements.get('lg-bundle-selections')) {
  class LgBundleSelections extends HTMLElement {
    constructor() {
      super();
      this.bundleItems = []
    }

    connectedCallback () {
      this.discount = this.dataset.discount;
      this.mainId = this.dataset.id
      this.bundleSize = parseInt(this.dataset.bundleSize)
      this.bundleId = this.dataset.bundleId
      this.miniCart = document.querySelector('mini-cart');
      this.submitButton = this.querySelector('.js-bundle-submit')
      this.submitButton.addEventListener('click', this.onSubmit.bind(this))
      window.addEventListener('bundle:selected', this.handleSelection.bind(this))
    }

    handleSelection (e) {
      if (e.detail.bundleId !== this.bundleId) return;

      const items = this.bundleItems.filter(item => item.product_id !== e.detail.item.product_id)
      this.bundleItems = [
        ...items,
        e.detail.item
      ]

      const totalPrice = this.bundleItems.map(item => item.price).reduce((a, b) => a + b, 0)
      const discountedPrice = totalPrice - Number(this.discount) * 100
      const buttons = document.querySelectorAll(`.js-product-form[data-bundle-id="${this.bundleId}"] .js-bundle-submit`)

      this.querySelectorAll('.js-bundle-price').forEach(el => el.innerHTML = window.theme.Currency.formatMoney(totalPrice, window.shopSettings.moneyFormat.toLowerCase()))
      this.querySelectorAll('.js-sale-price').forEach(el => el.innerHTML = window.theme.Currency.formatMoney(discountedPrice, window.shopSettings.moneyFormat.toLowerCase()))
      console.log(buttons)
      buttons.forEach(submitButton => {
        if (this.bundleItems.length === this.bundleSize) {
          submitButton.removeAttribute('disabled')
        } else {
          submitButton.setAttribute('disabled', true)
        }

        submitButton.querySelectorAll('.js-bundle-price').forEach(el => el.innerHTML = window.theme.Currency.formatMoney(totalPrice, window.shopSettings.moneyFormat.toLowerCase()))
        submitButton.querySelectorAll('.js-sale-price').forEach(el => el.innerHTML = window.theme.Currency.formatMoney(discountedPrice, window.shopSettings.moneyFormat.toLowerCase()))
      })

      document.querySelectorAll(`.js-product-form[data-bundle-id="${this.bundleId}"] .js-bundle-ready`).forEach(el => el.classList[this.bundleItems.length === this.bundleSize ? 'remove' : 'add']('hidden'))
      document.querySelectorAll(`.js-product-form[data-bundle-id="${this.bundleId}"] .js-bundle-pending`).forEach(el => el.classList[this.bundleItems.length !== this.bundleSize ? 'remove' : 'add']('hidden'))
    }

    async onSubmit (e) {
      e.preventDefault()

      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
      const bundleId = crypto.randomUUID()

      const items = this.bundleItems.map(item => ({
        id: item.id,
        quantity: 1,
        properties: {
          _is_bundle: true,
          _bundle_id: bundleId,
          _parent_id: this.mainId
        }
      }))

      const body = JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname
      })

      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');

      fetch(`${window.routes.cart_add_url}.js`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              detail: {
                errorMessage: parsedState.description
              }
            }));
        }
        else {
          this.miniCart && this.miniCart.renderContents(parsedState);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: parsedState
            }
          }));
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.classList.remove('loading');
      });
    }
  }

  customElements.define('lg-bundle-selections', LgBundleSelections);
}

if (!customElements.get('lg-bundle-item')) {
  class LgBundleItem extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.onVariantChange.bind(this))
    }

    connectedCallback () {
      this.optionSize = parseInt(this.dataset.optionsSize)
      this.selectionSize = parseInt(this.dataset.selectionSize)
      this.variantData = JSON.parse(this.querySelector('[data-variants]').textContent)
      this.excludedVariants = JSON.parse((this.querySelector('[data-excluded-variants]').textContent)).map(variant => variant.id)
      this.bundleId = this.dataset.bundleId

      this.onVariantChange(this.selectionSize === 1)
      this.querySelectorAll('input[type="radio"]:not(:disabled)').forEach(input => input.addEventListener('click', () => {
        if (input.nextElementSibling.classList.contains('no-focus')) {
          this.onVariantChange(true)
        }
      }))
    }

    onVariantChange (e) {
      this.updateOptions();
      this.updateMasterId();

      if (this.currentVariant) {
        if (!!e) {
          this.updateVariantInfo()
          this.sendSelectionEvent()
        }

        this.setAvailability()
        this.setOptionsVisibility()

        if (!this.querySelector('.product-form__input:not(.hidden) input[type="radio"]') && !e) {
          this.sendSelectionEvent()
        }
      }

      if (!!e) {
        this.querySelectorAll('input[type="radio"] + label').forEach(label => {
          label.classList.remove('no-focus')
        })
      }
    }

    updateOptions () {
      this.options = Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      });
    }

    updateMasterId () {
      this.currentVariant = this.variantData.find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateVariantInfo () {
      if (this.currentVariant.featured_image) {
        this.querySelectorAll('.js-variant-image').forEach(image => {
          image.classList[+image.dataset.variantId === +this.currentVariant.id ? 'remove': 'add']('hidden')
        })
      }

      this.querySelectorAll('.js-variant-label').forEach(el => el.innerHTML = this.currentVariant.title)
      this.querySelector('.js-variant-label-description').innerHTML = this.currentVariant.description

      this.querySelector('.js-variant-id').value = this.currentVariant.id
      this.querySelector('.js-variant-price').value = this.currentVariant.price
    }

    setAvailability () {
      const currentlySelectedValues = this.options.map((value,index) => {return {value, index: `option${index+1}`}})
      const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

      for (var [option, values] of Object.entries(initialOptions)) {
        this.manageOptionState(option, values);
      }
    }

    setOptionsVisibility () {
      this.querySelectorAll('fieldset').forEach(fieldset => {
        const activeOptions = Array.from(fieldset.querySelectorAll('input:not(:disabled)'))
        fieldset.classList[activeOptions.length > 1 ? 'remove' : 'add']('hidden')
      })
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], soldOut: true, excluded: this.excludedVariants.includes(variant.id) }
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
          const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.soldOut = entry.soldOut && variant.available && !this.excludedVariants.includes(variant.id) ? false : entry.soldOut;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant['option1'] === currentOption1.value) {
                entry.soldOut = entry.soldOut && variant.available && !this.excludedVariants.includes(variant.id) ? false : entry.soldOut;
              }
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (
                currentOption1 && variant['option1'] === currentOption1.value
                && currentOption2 && variant['option2'] === currentOption2.value
              ) {
                entry.soldOut = entry.soldOut && variant.available && !this.excludedVariants.includes(variant.id) ? false : entry.soldOut;
              }
          }
        })

        return options;
      }, { option1: [], option2: [], option3: []})
    }

    manageOptionState(option, values) {
      const group = this.querySelector('fieldset[data-option-index="'+ option +'"]');

      // Loop through each option value
      values.forEach(obj => {
        const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
        const input = group.querySelector('input[data-option-value="'+ value +'"]');

        if (obj.soldOut) {
          input.setAttribute('disabled', '');
          input.nextElementSibling.innerHTML = '<div class="strike_line">&nbsp;</div>'
          input.nextElementSibling.classList.add('unavailable_variant')
        } else {
          input.removeAttribute('disabled')
          input.nextElementSibling.innerHTML = ''
          input.nextElementSibling.classList.remove('unavailable_variant')
        }
      });
    }

    sendSelectionEvent () {
      console.log(this.bundleId)
      window.dispatchEvent(new CustomEvent('bundle:selected', {
        bubbles: true,
        detail: {
          item: this.currentVariant,
          bundleId: this.bundleId
        }
      }))
    }
  }

  customElements.define('lg-bundle-item', LgBundleItem);
}

if (!customElements.get('sticky-bundle-form')) {
  class StickyBundleForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback () {
      this.bundleId = this.dataset.bundleId
      this.submitButton = this.querySelector('.js-bundle-submit')
      this.submitButton.addEventListener('click', this.onSubmit.bind(this))

      this.querySelector('.js-bundle-pending').addEventListener('click', this.onPendingClick.bind(this))
    }

    onPendingClick () {
      const bundleElement = document.querySelector(`lg-bundle-selections[data-bundle-id="${this.bundleId}"]`)

      window.scrollTo({ top: bundleElement.offsetTop - 100, behavior: 'smooth' })
    }

    async onSubmit (e) {
      e.preventDefault()

      window.dispatchEvent(new CustomEvent('bundle:submit', {
        bubbles: true,
        detail: {
          bundleId: this.bundleId
        }
      }))

      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');

      setTimeout(() => {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.classList.remove('loading');
      }, 1500)
    }
  }

  customElements.define('sticky-bundle-form', StickyBundleForm);
}